<template>
  <v-container fluid class="principal-body" color="background" style="height: 100%; overflow-y: auto;">
    <v-row justify="center" style="font-size: 20px">
      <b>{{ $t('Profile.My profile') }}</b>
    </v-row>
    <div class="my-view" />
    <v-row justify="center" style="margin-left: 20px; margin-right: 20px">
      <v-col>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <h5>{{ $t('CIF/NIF') }}</h5>
          <v-text-field
            ref="formCif"
            v-model="cif"
            :rules="rules.cif"
            required
            name="cif"
            type="text"
          />
          <h5>{{ $t('Profile.Name') }}</h5>
          <v-text-field
            ref="formName"
            v-model="name"
            :rules="rules.name"
            required
            name="name"
            type="text"
          />

          <h5>{{ $t('Profile.Surname') }}</h5>
          <v-text-field
            ref="formSurname"
            v-model="surname"
            :rules="rules.surname"
            name="surname"
            required
            type="text"
          />
          <h5>{{ $t('Phone number') }}</h5>
          <v-text-field
            ref="formPhone"
            v-model="phone"
            :rules="rules.phone"
            name="phone"
            required
            type="number"
          />
          <h5> {{ $t('Email') }} </h5>
          <v-text-field
            ref="formEmail"
            v-model="email"
            :rules="rules.email"
            name="email"
            required
            type="text"
          />
          <h5> {{ $t('Profile.Address') }} </h5>
          <v-text-field
            ref="formAddress"
            v-model="address"
            :rules="rules.address"
            name="address"
            required
            type="text"
          />
          <h5>{{ $t('Profile.Country') }}</h5>
          <v-select
            ref="formCountry"
            v-model="country"
            name="country"
            :items="items"
          />
          <h5>{{ $t('chat.stipe-public-key') }}</h5>
          <v-text-field
            ref="formPublicKey"
            v-model="stripePublicKey"
            name="stripe public key"
            required
            type="text"
          />
          <h5>{{ $t('chat.stipe-private-key') }}</h5>
          <v-text-field
            ref="formPrivateKey"
            v-model="stripePrivateKey"
            name="stripe private key"
            required
            type="password"
          />
          <h5>{{ $t('Wallet Address') }}</h5>
          <v-text-field
            ref="walletAddress"
            v-model="walletAddress"
            name="walletAddress"
            required
            type="text"
          />
          <h5>{{ $t('IBAN') }}</h5>
          <v-text-field
            ref="iban"
            v-model="iban"
            name="iban"
            required
            type="text"
          />
          <v-checkbox v-model="dontShowAgain" :label="$t('Profile.Don\'t show the splash screen at the beggining')" />
        </v-form>
        <v-row justify="center">
          <v-col cols="6" align="center">
            <v-btn block color="styleBtn" style="margin-top: 25px" dark depressed x-large @click="workingOnIt()">
              {{ $t('Profile pic') }}
            </v-btn>
          </v-col>
          <v-col cols="6" align="center">
            <v-btn block class="backBtn" style="margin-top: 25px" depressed x-large text @click="goBack()">
              {{ $t('Back') }}
            </v-btn>
          </v-col>
          <v-col cols="6" align="center">
            <v-btn block class="styleBtn"  dark :disabled="!valid" depressed x-large @click="saveForm">
              {{ $t('Save') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6" lg="6" md="6" xl="6" align="center">
            <v-btn block color="#FF6961" style="margin-top: 25px; border-radius: 10px;" dark depressed x-large @click="doLogout">
              {{ $t('Logout') }}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" lg="6" md="6" xl="6" align="center">
            <v-btn block class="styleBtn" style="margin-top: 25px" dark depressed x-large @click="addBytosToMetamask">
              {{ $t('Add byto symbol') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import LocalRepository from "../repositories/LocalRepository";
import SmartRepository from "@/repositories/SmartRepository";

export default {
    name: "Profile",
    data () {
        return {
            name: '',
            surname: '',
            phone: '',
            email: '',
            address: '',
            cif: '',
            dontShowAgain: false,
            valid: false,
            country: 'Spain',
            stripePublicKey: '',
            stripePrivateKey: '',
            eurToBytoRatio: '',
            walletAddress: '',
            iban: '',
            isFactor: false,
            isAdmin: false,
            platformAmount: 0,
            payerComission: 0,
            receiverComission: 0,
            percentageInvoicePayer: 0,
            percentageInvoiceReceiver: 0,
            platformComission: 0,
            platformStripePublic: '',
            platformStripePrivate: '',
            platformWalletAddress: '',

            userCommision: 0,
            platformCommision: 0,
            items: [
                'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
                'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Bolivia', 'Bosnia and Herzegovina',
                'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Côte d\'Ivoire', 'Cabo Verde', 'Cambodia', 'Cameroon',
                'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba',
                'Cyprus', 'Czechia', 'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador',
                'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'Gabon', 'Gambia',
                'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Hati', 'Holy See', 'Honduras',
                'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan',
                'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechetenstein', 'Lithuania',
                'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico',
                'Micronesia', 'Moldova', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
                'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine State',
                'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis',
                'Saint Lucia', 'Saint Vincent and the Greandines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
                'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka',
                'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia',
                'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States of America', 'Uruguay', 'Uzbekistan',
                'Vanuatu', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
            ],
            rules: {
                name: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                surname: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                phone: [
                    v => !!v || this.$t('The phone field is required'),
                    v => /^(\+?[\d ]{9,}|)$/.test(v) || this.$t('The phone must be valid')
                ],
                email: [
                    v => !!v || this.$t('Error.The mail field is required'),
                    v => /.+@.+\..+/.test(v) || this.$t('The mail must be valid.')],
                address: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                cif: [
                    val => (val || '').length > 0 || this.$t('Error.This field is required'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)')
                ]
            },
        };
    },
    watch: {
        dontShowAgain: function () {

        }
    },
    created () {
        this.initForm();
        this.payerComission = this.$parameters.payerComission;
        this.receiverComission = this.$parameters.receiverComission;
        this.platformComission = this.$parameters.platformComission;
        this.percentageInvoicePayer = this.$parameters.percentageInvoicePayer;
        this.percentageInvoiceReceiver = this.$parameters.percentageInvoiceReceiver;
        this.getMarketParameters();
        this.getWalletParameters();
        this.getExchangeRatios();
        if (this.$user.role === Constants.USER.ROLE_ADMIN) {
            SmartRepository.call(Constants.contractMarketplace, "balanceTokens", [])
                .then((amount) => {
                    this.platformAmount = SmartRepository.decodeEther(amount).toString();
                }).catch((e) => {
                    let message = e.toString();
                    if (e.message) {
                        message = e.message;
                    }
                    if (e.data && e.data.message) {
                        message = e.data.message;
                    }
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
        }
    },
    methods: {
        goBack () {
            this.$router.go(-1);
        },
        goToLanding () {
            window.location.replace(Constants.LANDING_BASE_URL);
        },
        initForm () {
            this.cif = this.$user.cif;
            this.name = this.$user.name;
            this.surname = this.$user.surname;
            this.phone = this.$user.phone;
            this.email = this.$user.email;
            this.address = this.$user.address;
            this.country = this.$user.country;
            this.dontShowAgain = !this.$user.showSplashScreen;
            this.isFactor = this.$user.role === Constants.USER.ROLE_FACTOR;
            this.isAdmin = this.$user.role === Constants.USER.ROLE_ADMIN;
            this.stripePublicKey = this.$user.stripePublickey;
            this.stripePrivateKey = this.$user.stripePrivatekey;
            this.walletAddress = this.$user.walletAddress;
            this.iban = this.$user.iban;
        },
        saveForm () {
            let newRole;
            if (this.isAdmin) {
                newRole = Constants.USER.ROLE_ADMIN;
            } else if (this.isFactor) {
                newRole = Constants.USER.ROLE_FACTOR;
            } else {
                newRole = Constants.USER.ROLE_USER;
            }
            ApiRepository.saveUser(this.cif, this.name, this.surname, this.phone, this.email, this.address, this.country, newRole, this.$user._id, this.payerComission, this.receiverComission, this.platformComission, this.stripePublicKey, this.stripePrivateKey, this.walletAddress, this.iban, this.percentageInvoicePayer, this.percentageInvoiceReceiver, this.userCommision, this.platformCommision, this.platformWalletAddress, this.platformStripePublic, this.platformStripePrivate, this.eurToBytoRatio)
                .then(() => {
                    ApiRepository.getParameters().then((res) => {
                        if (res && res.data && res.data.params) {
                            this.$parameters = res.data.params;
                            this.payerComission = this.$parameters.payerComission;
                            this.receiverComission = this.$parameters.receiverComission;
                            this.platformComission = this.$parameters.platformComission;
                            const dec = !this.dontShowAgain;
                            ApiRepository.updateDecision(this.$user.email, dec)
                                .then(() => { })
                                .catch((err) => {
                                    console.log(err);
                                });
                        }
                    }).catch((err) => {
                        console.log(err);
                    }).finally(() => {
                        this.$root.$emit('show-snackbar', {message: this.$t('Saved successfully!')});
                        this.$emit('success');
                        this.$router.push({name: 'InvoiceChats'});
                    });
                    this.getMarketParameters();
                    this.getWalletParameters();
                    this.getExchangeRatios();

                })
                .catch((err) => {
                    let miss = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_CIF) {
                        miss = this.$t('Already exists a user with this CIF');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_MAIL) {
                        miss = this.$t('Already exists a user with this Email');
                    } else {
                        miss = this.$t('Error.Something went wrong');
                    }
                    this.$root.$emit('show-snackbar', {message: miss, color: 'error'});
                    this.$emit('error');
                    console.error(err);
                });
        },
        doLogout () {
            this.$root.$emit('show-confirmation-modal', {
                title: this.$t('Logout'),
                message: this.$t('Profile.Do you want to logout?'),
                yes: () => {
                    LocalRepository.clear('token');
                    this.$root.$emit('show-snackbar', {message: 'Profile.Logged out succesfully!', color: "success"});
                    this.$router.push({name: 'Logout', replace: true}).catch(() => {});
                }
            });
        },
        workingOnIt () {
            this.$root.$emit('show-confirmation-modal', {
                title: this.$t('Working.onIt'),
                message: this.$t('We.areWorking'),
                yes: () => {
                    this.$router.go(-1);
                },
                no: () => {
                    this.$router.go(-1);
                }
            });
        },
        getMarketParameters () {
            ApiRepository.getParametersMarket().then((res) => {
                this.percentageInvoiceReceiver =  res.data.params.percentageInvoiceReceiver;
                this.percentageInvoicePayer =  res.data.params.percentageInvoicePayer;
                this.userCommision = res.data.params.userCommision;
                this.platformCommision = res.data.params.platformCommision;

            }).catch((err) => {
                this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                console.log(err);
            });
        },
        getWalletParameters () {
            ApiRepository.getPlatformAccounts().then((res) => {
                this.platformWalletAddress = res.data.accounts.walletAddress;
                this.platformStripePublic = res.data.accounts.stripe.public_key;
                this.platformStripePrivate = res.data.accounts.stripe.private_key;
            }).catch((err) => {
                this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                console.log(err);
            });
        },
        getExchangeRatios () {
            ApiRepository.getExangeRatios().then((res) => {
                this.eurToBytoRatio = res.data.exangeRatios.eurToByto;
            }).catch((err) => {
                this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                console.log(err);
            });
        },
        addBytosToMetamask () {
            SmartRepository.addBytos().then(() => {});
        }
    }
};
</script>

<style scoped>
.my-view{
  content: '';
  width: 80%;
  height: 1px;
  background-color: #0AE7C1 ;
  margin-top: 3%;
  margin-bottom: 3%;
  position: relative;
  transform: translateY(-50%);
  left: 10%;
  right: 10%;
}

.styleBtn{
background:linear-gradient(180deg, #10A4EA 0%, #0AE7C1 100%);
  border-radius: 10px;
}
.backBtn{
border: #0AE7C1 solid;
border-radius: 10px;
}
</style>
